<app-header-inner></app-header-inner>
 <!-- Subheader Start -->

<div  class="subheader dark-overlay dark-overlay-2" 
style="padding: 126px 0 2px;min-height: 211px !important;background-image: url('https://s3.eu-central-1.amazonaws.com/heek-media/images/industries/food/food-burger/cover-2.jpg')">
    <div class="container">
      <div class="row">
			<div class="col-12 col-md-6">
				<h1>Checkout</h1>
			</div>
			<div class="col-12 col-md-6">
				<h3 style="float:right;color:white">{{myCartDateTime}}</h3>
			</div>
		</div>
	  <div class="subheader-inner">
		
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Checkout</li>
          </ol>
        </nav>
      </div>

    </div>
  </div>
  <!-- Subheader End -->

  <!-- Checkout Start -->
  <section class="section">
    <div class="container">
 
        <div class="row">
          <div class="col-xl-7">
            <!-- Login -->
            <div class="ct-notice d-none">
              <p>Are you a returning customer? <a href="#">Click here to login</a> </p>
            </div>
            <div class="ct-notice-content d-none" >
              <div class="row">
                <div class="col-xl-6 form-group">
                  <label>Email Address</label>
                  <input type="text" class="form-control" name="login-email" placeholder="Email Address" value="">
                </div>
                <div class="col-xl-6 form-group">
                  <label>Password</label>
                  <input type="password" class="form-control" name="login-pass" placeholder="Password" value="">
                </div>
                <div class="col-12 form-group">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="rememberMe">
                    <label class="custom-control-label" for="rememberMe">Remember Me</label>
                  </div>
                </div>
                <div class="col-12">
                  <button type="submit" class="btn-custom shadow-none btn-sm" name="button">Login</button>
                </div>
              </div>
            </div>
            <!-- Coupon Code -->
            <div class="ct-notice d-none">
              <p>Do you have a coupon code? <a href="#">Click here to apply</a> </p>
            </div>
            <div class="ct-notice-content d-none">
              <p>If you have a coupon code, apply it below</p>
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Coupon Code">
                <div class="input-group-append">
                  <button class="btn-custom shadow-none" type="button">Apply Code</button>
                </div>
              </div>
            </div>
			<form [formGroup]="checkOutForm"  (ngSubmit)="checkOutProccess()" autocomplete="off" >
			
			<div class="row" *ngIf='service_type==="Delivery"'>
			<h4>Delivery Information</h4>
			<div class="col-md-12">
				<div  *ngFor="let dAddress of deliveryAddressSaved">
				<p *ngIf = "dAddress.fulladdress" class="mb-0"><strong>Address</strong> {{dAddress.fulladdress}}</p>	
				<p *ngIf = "dAddress.zipcode" class="mb-0"><strong>Zip Code</strong> {{dAddress.zipcode}}</p>	
				<p *ngIf = "dAddress.apartment" class="mb-0"><strong>Apartment</strong> {{dAddress.apartment}}</p>	
				
				</div>
			</div>			
			<div class="col-xl-12 mb-3">
                <label>Delivery Instruction</label>
				<p [ngClass]="{ 'has-error': isSubmitted && formControls.deliveryinstruction.errors }">
				<textarea type="text" class="form-control" 
					formControlName="deliveryinstruction" rows='5'
					style="height: auto !important;"></textarea>
				</p>
			</div>
			</div>
			
			<h4 class="left-div">Payment</h4>
			<div class="row left-div">
			 
				<div class="col-xl-12 mb-3" *ngIf="showGiftCardLink==='1'">
					<span class="btn p-1 m-1 " 
							[ngClass]="{'btn-outline-danger': payment_via != 'creditcard', 'btn-danger':payment_via ==='creditcard' }"
							(click)="paymentViaSet('creditcard')">Credit card</span>
					<span class="btn p-1 m-1 "
							[ngClass]="{'btn-outline-danger': payment_via != 'giftcardf4', 'btn-danger':payment_via ==='giftcardf4' }"
							(click)="paymentViaSet('giftcardf4')">Gift Card</span>		
				</div>
				<div class="form-group col-xl-6">
					<label>Cardholder's first name <span class="text-danger">*</span></label>
					<p [ngClass]="{ 'has-error': isSubmitted && formControls.first_name.errors }">
					 <input type="text" placeholder="Cardholder's first name" name="first_name" 
					formControlName="first_name"
					 class="form-control" value="" required="">
					</p>
			    </div>
				<div class="form-group col-xl-6">
					<label>Cardholder's last name <span class="text-danger">*</span></label>
					<p >
					 <input type="text" placeholder="Cardholder's last name" name="last_name" 
					formControlName="last_name"
					 class="form-control" value="" required="">
					</p>
			    </div>
				
				<div class="col-xl-6 mb-3">
				<label>Card Number</label>
				
				<p [ngClass]="{ 'has-error': isSubmitted && formControls.card_number.errors }">
				<input type="text" name="card_number" id="account_number"
				formControlName="card_number"
				placeholder="1234 5678 9012 3456" maxlength="16" class="visa valid form-control">
				</p>
				
				</div>
			
			 
			  
              <div class="col-xl-6 mb-3 "  *ngIf="payment_via === 'giftcardf4'">
                <label >Pin*</label>
				<p [ngClass]="{ 'has-error': isSubmitted && formControls.card_cvv.errors }">
				<input type="text" class="form-control" 
					formControlName="card_cvv"
					placeholder="Pin" value="" pattern="\d*" id="pin">
				</p>
			  </div>
			  <div class="col-xl-6 mb-3 "  *ngIf="payment_via === 'creditcard'">
                <label>CVV*</label>
				<p [ngClass]="{ 'has-error': isSubmitted && formControls.card_cvv.errors }">
				<input type="text" class="form-control" 
					formControlName="card_cvv"
					placeholder="CVV" value="" pattern="\d*">
				</p>
			  </div>
			  
			
		    </div>
		  
		
            <!-- Buyer Info -->
            <!-- <h4 *ngIf="error"></h4> -->
            <div class="row left-div">
            
			  <div class="form-group col-xl-12">
               <p class="small">Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our <a class="btn-link" href="https://cygnuspay.com/privacy.php" target="_blank">privacy policy.</a> </p>
                <div class="row">
					<div class="col-xl-12">
					
					  <div *ngIf="cardErrorApiCall!=''" class="alert alert-danger">
						  <strong>Error !</strong> {{cardErrorApiCall}}
						</div>
					</div>
				</div>
			    <button *ngIf="!checkOutSpin && service_type!=''" type="submit" class="btn-custom primary btn-block" (click)="verfiyAccount()">Continue</button>
				<div  *ngIf="checkOutSpin" class="category-box-icon d-flex">
				<i class="fas fa-spinner spinner"></i>
				</div>
			  </div>
            </div>
		    </form>

            <!-- /Buyer Info -->

          </div>
          <div class="col-xl-5 checkout-billing left-div">
            <!-- Order Details Start -->
            <table class=" cart-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Quantity</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody *ngFor="let checkRcord of checkOutData" style="border-bottom:1px solid rgba(0,0,0,.1)">
				
                <tr >
                  <td >
                    <div >
                      <div class="cart-product-body">
                        <h6> <a >{{checkRcord.subMeuName}}</a> </h6>
                      </div>
                    </div>
                  </td>
                  <td > {{checkRcord.ItemQty}} </td>
                  <td > <strong>${{checkRcord.ItemBasePrice*checkRcord.ItemQty | number : '1.2-2' }}</strong> </td>
                </tr>
				<tr *ngFor="let addOn of checkRcord.addOns ; last  as  isLast;">
                <td class="pt-0 pb-0" [ngClass]="{ 'last-modifer-td': isLast }">
                    <div class="cart-product-wrapper">
                      <div class="cart-product-body">
                        <p>
						<i class="fa fa-adjust fa-3x fa-circel-icon" *ngIf="addOn.pizaextra_name==='left'"></i>
						<i class="fa fa-circle fa-3x fa-circel-icon" *ngIf="addOn.pizaextra_name==='full'"></i>
						<i class="fa fa-adjust fa-3x fa-rotate-180 fa-circel-icon" *ngIf="addOn.pizaextra_name==='right'"></i>
					
						{{addOn.name}} </p>
                      </div>
                    </div>
                  </td>
                  <td  class="pt-0 pb-0" [ngClass]="{ 'last-modifer-td': isLast }"></td>
                  <td  class="pt-0 pb-0" [ngClass]="{ 'last-modifer-td': isLast }">
					<span *ngIf="addOn.pizaextra_name===''">
					${{addOn.amount*checkRcord.ItemQty | number : '1.2-2'  }}
					</span>
					<span style="float: right;" *ngIf="addOn.pizaextra_name!=''">
						{{pizaToppingPriceCart(checkRcord,addOn ) }} 
					</span>
				  </td>
                </tr>
				
              </tbody>
			  <tbody>
			   <tr class="total-cart">
                  <th>
                    <h6 class="mb-0 text-white">Sub Total</h6>
                  </th>
                  <th></th>
                  <th> <strong>${{cartTotalBalance | number : '1.2-2' }}</strong> </th>
                </tr>
				<tr class="total-cart" *ngFor="let grandtax of francaisTax">
                  <th>
                    <h6 class="mb-0 text-white">{{grandtax.sales_tax_desc}} ({{grandtax.sales_tax_percentage}}%)</h6>
                  </th>
                  <th></th>
                  <th> <strong>${{grandtax.amount | number : '1.2-2' }}</strong> </th>
                </tr>
				
				<tr class="total-cart" >
                  <th>
                    <h6 class="mb-0 text-white">Discount</h6>
                  </th>
                  <th></th>
                  <th> <strong>${{discountAmount | number : '1.2-2' }}</strong> </th>
                </tr>
				<tr class="total-cart"  *ngIf="deliveryamount>0">
                  <th>
                    <h6 class="mb-0 text-white">Delivery Free</h6>
                  </th>
                  <th></th>
                  <th> <strong>${{deliveryamount | number : '1.2-2' }}</strong> </th>
                </tr>
				<tr class="total-cart"  *ngIf="is_surcharge_enabled==='1'">
                  <th>
                    <h6 class="mb-0 text-white">{{surcharge_label}}</h6>
                  </th>
                  <th></th>
                  <th> <strong>${{surcharge_amount | number : '1.2-2' }}</strong> </th>
                </tr>
				<tr class="total-cart"  *ngIf="enable_factor4==='1'">
                  <th>
                    <h6 class="mb-0 text-white">Loyalty Reward $:</h6>
                  </th>
                  <th></th>
                  <th> <strong>${{loyalityrewardamount | number : '1.2-2' }}</strong> </th>
                </tr>
				<tr class="total-cart"  *ngIf="enable_factor4==='1'">
                  <th>
                    <h6 class="mb-0 text-white">Gift Card $:</h6>
                  </th>
                  <th></th>
                  <th> <strong>${{giftcard_amount | number : '1.2-2' }}</strong> </th>
                </tr>
				<tr class="total-cart"  *ngIf="tip_amount>0">
                  <th>
                    <h6 class="mb-0 text-white">Tip</h6>
                  </th>
                  <th></th>
                  <th> <strong>${{tip_amount | number : '1.2-2' }}</strong> </th>
                </tr>
				
				<tr class="total-cart" >
                  <th>
                    <h6 class="mb-0 text-white">Grand Total</h6>
                  </th>
                  <th></th>
                  <th> <strong>${{grandTotalwithTax-loyalityrewardamount-giftcard_amount | number : '1.2-2' }}</strong> </th>
                </tr>
				<tbody>
            </table>

           

            
            <!-- Order Details End -->

          </div>
		  
		  <div class="completediv col-md-12" style="display:none">
			<div  *ngIf="checkOutSpin" class="category-box-icon d-flex">
				<i class="fas fa-spinner spinner"></i>
			</div>
		  </div>
		  
        </div>

    </div>
<div class="modal" id="bookOrderSuccesModal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content  bookOrderSuccesModal-content">
      <div class="modal-header">
		<h5 class="modal-title">Book Order</h5>
    
      </div>
      <div class="modal-body">
		<div class="row">
		<div class="col-md-1">
		
		</div>
		<div class="col-md-10">
			<img src="assets/img/animation_gif.gif" style="width:100%">
        </div>	
		<div class="col-md-1">
		
		</div>
		</div>
      
		<p class="p-0 m-0 bookOrderMessageText">{{bookOrderApiMessage}}</p>
		
		<p class="p-0 m-0 bookOrderInfoText">Order Id : <span *ngIf="bookOrderResponse" style="font-size:22px">{{bookOrderResponse.order_id}}</span></p>
		<p class="p-0 m-0 bookOrderInfoText">Order Amount : <span *ngIf="bookOrderResponse" style="font-weight :100">${{bookOrderResponse.order_amount}}</span></p>
		<p class="p-0 m-0 bookOrderInfoText">Order Date : <span *ngIf="bookOrderResponse" style="font-weight :100">{{bookOrderResponse.order_date}}</span></p>
		<p style="font-style: italic;" class="p-0 m-0  bookOrderInfoText" *ngIf='francaisData.curbsideemail_instructions && service_type==="Curbside"'><b> {{francaisData.curbsideemail_instructions}} </b></p>

	  </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" >Ok</button>
      </div>
    </div>
  </div>
</div>
  </section>
  <!-- Checkout End -->
<app-footer></app-footer>